import {
    ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS,
    ADD_OR_UPDATE_TRANSFER_TYPE_FAILED,
    RESET_OR_UPDATE_TRANSFER_TYPE,
    LOADING_OR_UPDATE_TRANSFER_TYPE,
    NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE,
} from "../types";

const initialState = {
    isLoading: false,
    failed: false,
    success: false,
    data: {},
    networkError: "",
    invalidRequest: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_OR_UPDATE_TRANSFER_TYPE: {
            return {
                ...state,
                isLoading: true,
                failed: false,
                success: false,
                invalidRequest: false,
                data: {},
            };
        }
        case ADD_OR_UPDATE_TRANSFER_TYPE_FAILED: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case ADD_OR_UPDATE_TRANSFER_TYPE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                failed: false,
                success: true,
                invalidRequest: false,
                data: action.payload,
            };
        }
        case NETWORK_ERROR_OR_UPDATE_TRANSFER_TYPE: {
            return {
                ...state,
                isLoading: false,
                failed: true,
                success: false,
                invalidRequest: false,
                networkError: "Something went wrong. Check internet connection",
                data: {},
            };
        }
        case RESET_OR_UPDATE_TRANSFER_TYPE: {
            return (state = initialState);
        }

        default:
            return state;
    }
};
